import { combineReducers } from 'redux';

import appJoinedBraindateReducer from './appJoinedBraindateReducer';

const appBraindatesReducer = combineReducers({
  joined: appJoinedBraindateReducer,
});
export default appBraindatesReducer;
